<template>
  <div class="container">
    <div class="page-title">
      数据洞察机会，以智能方式<br/>创建<span class="jianbian"></span><span id="anli-typed"></span><span class="cursor">&nbsp;</span>
    </div>
    <div class="hot-anli">
      <div data-aos="fade-right" data-aos-delay="300">
        <el-image class="image" :src="topList.cover" fit="cover"></el-image>
      </div>
      <div data-aos="fade-left" data-aos-delay="300">
        <div class="title">{{ topList.title }}</div>
        <div class="content" style="-webkit-box-orient: vertical;">{{ topList.summary }}</div>
        <div class="btn-container">
          <el-button class="detail-btn" size="medium" @click="toDetail(topList.id)">查看详情</el-button>
          <el-button class="zixun-btn" type="warning" size="medium">免费咨询</el-button>
        </div>
      </div>
    </div>
    <div class="anli-container">
      <div class="industry" data-aos="fade-down-right">
        <ul class="list">
          <li class="title">按行业：</li>
          <li class="list-item" :class="{'active':item.dictValue == industry}" v-for="item in industryList"
              @click="setIndustry(item)">{{ item.dictLabel }}
          </li>
        </ul>
      </div>
      <div class="scene" data-aos="fade-down-right">
        <ul class="list">
          <li class="title">按场景：</li>
          <li class="list-item" :class="{'active':item.dictValue == scene}" v-for="item in sceneList"
              @click="setScene(item)">{{ item.dictLabel }}
          </li>
        </ul>
      </div>
      <div class="wrapper">
        <div data-aos="zoom-in-up" data-aos-delay="300" class="anli-item" v-for="(item,index) in dataList"
             :style="{'display':index>=8 ? 'none':'inline-block'}">
          <el-image class="cover-image" :src="item.cover" fit="cover"></el-image>
          <div class="title"
               style="word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden;">
            {{ item.title }}
          </div>
          <div class="abstrc" style="-webkit-box-orient: vertical;">{{ item.summary }}</div>
          <div class="bottom">
            <div class="tag">{{ industryType[item.industryId] }}</div>
            <div class="link" @click="toDetail(item.id)">查看详情
              <div class="icon-bg">
                <i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="showAll" :style="{'display':total<8?'none': !isCollapsed?'none':'block'}">
        <button class="showAll-btn" @click="showAllItem">展开全部</button>
      </div>
    </div>
    <Apply/>
  </div>
</template>

<script>
import {getIsTrial, getToken} from '@/utils/auth'
import {getList, getIndustry, getScene} from '@/api/anli/anli'
import {toLogin} from '@/api/isLogin'
import Apply from "@/components/Apply.vue";

export default {
  components: {
    Apply,
  },
  data() {
    return {
      industryList: [], //行业列表
      sceneList: [],//场景列表
      topList: {}, // 推荐案例
      dataList: [], //案例列表
      total: 0, //案例数量
      mobile: '',
      industry: '',
      scene: '',
      industryType: {},
      menuState: false,
      isCollapsed: true
    }
  },
  methods: {
    showAllItem() {
      if (getToken()) {
        this.isCollapsed = false
      } else {
        toLogin(this)
      }
    },
    setIndustry(item) {
      this.industry = item.dictValue
      this.getData({industryId: item.dictValue, sceneId: this.scene})
      this.$forceUpdate()
    },
    setScene(item) {
      this.scene = item.dictValue
      this.getData({industryId: this.industry, sceneId: item.dictValue})
      this.$forceUpdate()
    },
    async getData(data) {
      const res = await getList(data)
      if (res.code === 0) {
        if (res.data.list.length > 0) {
          this.dataList = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error('此行业/场景暂无案例')
        }
        this.topList = res.data.topList[0]
      } else {
        this.$message.error(res.msg)
      }
    },
    async getInsturyData() {
      const res = await getIndustry()
      if (res.code === 0) {
        for (var i = 0; i < res.data[0].dataList.length; i++) {
          this.industryType[res.data[0].dataList[i].dictValue] = res.data[0].dataList[i].dictLabel
        }
        this.industryList = res.data[0].dataList
        this.industryList.unshift({dictValue: '', dictLabel: '全部'})
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSceneData() {
      const res = await getScene()
      if (res.code === 0) {
        this.sceneList = res.data[0].dataList
        this.sceneList.unshift({dictValue: '', dictLabel: '全部'})
      } else {
        this.$message.error(res.msg)
      }
    },
    toDetail(id) {
      // if(getToken()){
      this.$router.push({name: 'anli-detail', params: {id: id}})
      /* }else{
        toLogin(this)
      } */
    },
    daziji() {
      const typedSpan = document.getElementById("anli-typed")
      const totype = ["业务传奇"]

      const delayTyping_char = 200;
      const delayErasing_text = 150;
      const delayTyping_text = 1000;

      let totypeIndex = 0;
      let charIndex = 0;

      function typeText() {
        if (charIndex < totype[totypeIndex].length) {
          typedSpan.textContent += totype[totypeIndex].charAt(charIndex);
          charIndex++;
          setTimeout(typeText, delayTyping_char);
        } else {
          setTimeout(eraseText, delayTyping_text);
        }
      }

      function eraseText() {
        if (charIndex > 0) {
          typedSpan.textContent = totype[totypeIndex].substring(0, charIndex - 1);
          charIndex = charIndex - 1;
          setTimeout(eraseText, delayErasing_text);
        } else {
          totypeIndex++;

          if (totypeIndex >= totype.length)
            totypeIndex = 0;
          setTimeout(typeText, delayTyping_text);
        }
      }

      if (totype[totypeIndex].length) setTimeout(typeText, delayTyping_text);
    },
    handleMouseEnter(event) {
      const images = event.currentTarget.querySelectorAll('img');
      images.forEach((img) => {
        img.style.transition = 'transform 0.5s ease';
        img.style.transform = 'scale(1.1)';
      });
    },
    handleMouseLeave(event) {
      const images = event.currentTarget.querySelectorAll('img');
      images.forEach((img) => {
        img.style.transform = 'scale(1)';
      });
    }
  },
  updated() {
    this.$nextTick(() => {
      const anliItems = document.querySelectorAll('.anli-item');
      anliItems.forEach((item) => {
        item.addEventListener('mouseenter', this.handleMouseEnter);
        item.addEventListener('mouseleave', this.handleMouseLeave);
      });
    });
  },
  async mounted() {

    this.daziji()
    if (this.$route.params.sceneId) {
      this.scene = this.$route.params.sceneId
      this.getData({sceneId: this.scene})
    } else {
      this.getData()
    }
    this.getInsturyData()
    this.getSceneData()

  }

}
</script>

<style lang="scss" scoped>
.container {
  width: 80vw;
  max-width: 1400px;
  margin: 0 auto;

  .page-title {
    text-align: center;
    font-size: 40px;
    font-weight: 800;
    //width: 500px;
    margin: 50px auto 100px;
    letter-spacing: 5px;
    color: #383838;

    .jianbian {
      background: linear-gradient(to right, #7868C4, #E387A8, #F3AD6A);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
  }

  .hot-anli {
    position: relative;

    & > div {
      width: calc(45% + 100px);
      border-radius: 40px;
      display: inline-block;
      height: 400px;

      &:nth-child(2) {
        z-index: 2;
        width: 55%;
        padding: 50px;
        background-color: #fff;
        position: absolute;
        margin-left: -100px;
        //height: -webkit-fill-available;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;
      }

      .image {
        width: 100%;
        height: 400px;
        border-radius: 40px;
      }

      .title {
        font-size: 30px;
        font-weight: 700;
        color: rgb(58, 64, 78);
      }

      .content {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        white-space: normal;
        margin: 10px auto;
        color: rgb(51, 51, 51);
        letter-spacing: 1px;
        line-height: 28px;
      }

      .detail-btn {
        color: #FF842E;
        border-color: #FF842E;
        border-radius: 50px;
        width: 150px;
      }

      .detail-btn:focus, .detail-btn:hover {
        background-color: #fff;
      }

      .zixun-btn {
        background-color: #FF842E;
        border-radius: 50px;
        width: 150px;
      }
    }

    .btn-container {
      position: absolute;
      bottom: 30px;
    }

  }

  .industry .title, .scene .title {
    display: inline-block;
  }

  .industry {
    margin: 55px 0 20px;
    color: rgb(58, 64, 78);
    font-weight: 500;
  }

  .scene {
    margin: 10px 0 55px;
    color: rgb(58, 64, 78);
    font-weight: 500;
  }

  .list {
    margin: 0;
    padding: 0;
    display: inline-block;

    li {
      margin-bottom: 5px;
    }

    .list-item {
      list-style: none;
      padding: 0 15px;
      display: inline-block;
      cursor: pointer;
      color: #000;
      //height: -webkit-fill-available;

      &.active {
        color: #FF842E;
        background-color: #F5F5F5;
        padding: 0 15px;
        border-radius: 20px;
      }

      &:hover {
        color: #FF842E;
      }
    }
  }

  .wrapper {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px; /* 设置间距 */
    //overflow: hidden;

    .anli-item {
      flex: 0 0 calc((100% - 60px) / 4); /* 每行4个，减去3个间距再分4份 */
      background-color: #fff;
      display: inline-block;
      border-radius: 10px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.05), 0 6px 10px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      position: relative;
      padding-bottom: 60px;

      .cover-image {
        width: 100%;
        height: 180px;
        border-radius: 10px 10px 0 0;
      }

      .title {
        font-size: 18px;
        font-weight: 800;
        color: #383838;
        width: 90%;
        margin: 25px auto 10px;
      }

      .abstrc {
        width: 90%;
        margin: 0 auto;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        color: #6d6d6d;
        letter-spacing: 1px;
      }

      .bottom {
        width: 90%;
        position: absolute;
        bottom: 20px;
        left: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tag {
          background-color: #dbf9e5;
          color: #4ba162;
          padding: 3px 12px;
          border-radius: 5px;
          font-size: 12px;
        }

        .link {
          display: flex;
          align-items: center;
          cursor: pointer;
          gap: 5px;

          .icon-bg {
            background-color: #ff842e;
            border-radius: 50%;
            width: 18px;
            height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;

            .el-icon-right {
              color: #fff;
            }
          }
        }
      }
    }
  }

  .showAll {
    text-align: center;
    margin: 80px auto 100px;

    .showAll-btn {
      border-radius: 20px;
      width: 140px;
      height: 38px;
      font-size: 15px;
      background-color: #fff;
      border: 1px solid #DCDFE6;
      color: #606266;
      cursor: pointer;
      transition: all 0.5s;
    }

    .showAll-btn:hover {
      border-color: #FF842E;
      color: #FF842E;
    }

  }

  .page-bottom {
    width: 100%;
    margin: 50px 0;
    position: relative;

    .content {
      width: 50%;
      position: absolute;
      top: 100px;
      left: 50%;
      // right: 0;
      margin-left: -25%;

      .title {
        font-size: 28px;
        font-weight: bold;
        margin: 20px 0;
        text-align: center;
      }

      .process {
        color: #454851;
        font-size: 16px;
        margin-bottom: 20px;
      }

      .iconfont {
        color: #BEBFC0;
        margin: 0 10px;
      }

      .input-wrapper {
        position: relative;

        .el-input {
          max-width: 490px;

          /deep/ .el-input__inner {
            border-radius: 20px;
            padding-left: 25px;
          }

        }

        /deep/ .el-input.is-active .el-input__inner,
        /deep/ .el-input__inner:focus {
          border-color: #C0C4CC;
        }

        .el-button--warning {
          background-color: #FF842E;
        }
      }

      .btn {
        position: absolute;
        bottom: 0;
        right: 0;
        border-radius: 20px;
        padding: 12px 32px;
      }

    }
  }
}

@media (min-width: 1025px) and (max-width: 1260px) {
  .container {
    .page-bottom {
      .content {
        top: 70px;

        .title {
          font-size: 24px;
          margin: 20px 0;
        }

      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    .page-bottom {
      .content {
        top: 60px;

        .title {
          font-size: 24px;
          margin: 20px 0;
        }

      }
    }
  }

}

@media screen and (max-width: 767px) {
  .container {
    .page-bottom {
      .content {
        top: 50px;

        .title {
          font-size: 18px;
          margin: 10px 0;
        }

        .input-wrapper {
          position: relative;

          .el-input {
            /deep/ .el-input__inner {
              font-size: 12px;
              height: 30px;
              line-height: 30px;
            }
          }
        }

        .btn {
          position: absolute;
          bottom: 0;
          right: 0;
          border-radius: 20px;
          padding: 0 32px;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }

}
</style>
<style>
.wrapper {
//height: 100vh; width: auto; //display: flex; justify-content: center; align-items: center;
}

.effect-wrapper {
  text-align: center;
  font-weight: normal;
}

#anli-typed {
  font-weight: bold;
  color: transparent;
  background: linear-gradient(to right, #7868C4, #E387A8, #F3AD6A);
  background-clip: text;
  margin-left: 5px;
  font-size: 40px;
}

.cursor {
  display: inline-block;
  width: 3px;
  margin-left: 3px;
  animation: blinker 800ms infinite;
}

.cursor.typing-true {
  animation: none;
}

@keyframes blinker {
  0% {
    background-color: #FF842E;
  }
  50% {
    background-color: transparent;
  }
  100% {
    background-color: #FF842E;
  }
}
</style>
